const DataStyler = require("../../style").DataStyler;
const BaseRenderer = require("./base_renderer");
const maps = require("../../maps");

/**
 * Default renderer.
 * @extends woosmap.layers.renderers.BaseRenderer
 * @memberOf woosmap.layers.renderers
 * @since 1.3.0
 */
class DefaultRenderer extends BaseRenderer {
    /**
     * @param {RendererOptions} options
     * @param {Object} options
     */
    constructor(options) {
        super(options);

        this._dataStyler = new DataStyler(this.styler);
        this._data = maps.data.getData();
        this._dataStyler.style(this._data);
    }

    /**
     *
     * @param {String} event
     * @param {StoreEventCallback} listener
     * @private
     */
    _addGoogleEventListener(event, listener) {
        maps.events.addListener(this._data, event, (event) => {
            event.feature.toGeoJson(listener);
        });
    }

    /**
     * Add the geojson in the google.maps.Data instance
     * @private
     * @param {GeoJSON} geojson
     */
    _addGeojsonToData(geojson) {
        this._data.addGeoJson(geojson, { idPropertyName: "store_id" });
    }

    /**
     * Remove a feature from the google.maps.Data instance
     * @private
     * @param feature
     */
    _removeFeatureFromData(feature) {
        this._data.remove(feature);
    }

    /**
     * Getter to access to the map instance
     * @returns {google.maps.Map}
     */
    getMap() {
        return this._data.getMap();
    }

    /**
     * Set the map instance
     * @param {google.maps.Map} map
     */
    setMap(map) {
        this._data.setMap(map);
    }

    /**
     * Call to display the stores with the basic style
     * @param {GeoJSON} stores
     */
    displayStores(stores) {
        // Style once per cycle: setStyle re-renders the whole layer, so calling
        // it per tile is O(features x tiles). Re-armed on clear().
        if (!this._styled) {
            this._dataStyler.style(this._data);
            this._styled = true;
        }
        this._addGeojsonToData(stores);
        if (this._selectedStore) {
            this._dataStyler.selectStore(this._data, this._selectedStore);
        }
    }

    /**
     * Call to display the stores with the numbered style
     * @param {GeoJSON} stores
     */
    displayNumberedStores(stores) {
        this._addGeojsonToData(stores);
        this._dataStyler.styleNumbered(this._data, stores.features);
    }

    /**
     * Called once all tiles request are finished.
     */
    tilesDidLoad() {}

    /**
     * Use the `selected` style for the `selectedStore`
     * @param {Store} selectedStore the store to select.
     */
    selectStore(selectedStore) {
        super.selectStore(selectedStore);
        this._selectedStore = selectedStore;
        this._dataStyler.selectStore(this._data, selectedStore);
    }

    /**
     * Removes all the data and style from the layer.
     */
    clear() {
        this._dataStyler.clear(this._data);
        this._styled = false;
        this._data.forEach((feature) => {
            this._removeFeatureFromData(feature);
        });
    }
}

module.exports = DefaultRenderer;
